import { createSelector } from 'reselect';

import { AppState, User, Error } from 'lib/types/global';

export const getState = (state: AppState) => state.session;

export const getSessionUser = (state: AppState): User | undefined =>
  getState(state).user;
export const getSessionError = (state: AppState): Error | undefined =>
  getState(state).error;
export const isSessionLoading = (state: AppState): boolean =>
  getState(state).loading;

// Computed
export const getSessionFeatures = createSelector(
  [getSessionUser],
  (user) => new Set(user?.features || []),
);

export const getSessionUserId = createSelector(
  [getSessionUser],
  (user) => user?.id,
);

export const isSessionSso = createSelector(
  [getSessionUser],
  (user) => user?.isSso,
);

export const selectAvailableOrgIds = createSelector(
  [getSessionUser],
  (user) => user?.orgIds,
);

export const selectAvailableBranchIds = createSelector(
  [getSessionUser],
  (user) => user?.branchIds,
);
